import * as React from 'react';
import { useState } from 'react';
import { ErrorBoundarySessionStorageKey } from '../../configuration/error-boundary';
import { replacePlaceholders } from '../../utilities';
import { ICipReportIssueViewProps } from './cip-report-issue';

const CipReportIssueView: React.FC<ICipReportIssueViewProps> = props => {
    const [isCopied, setIsCopied] = useState(false);
    const { config } = props;
    const { title, text, emailAddress, contactLink } = config;
    const CLASS_NAME = 'cip-report-issue';

    const getErrorCode = () => {
        if (typeof window === 'undefined' || typeof window.sessionStorage === 'undefined') {
            return 'Session storage is not available';
        }
        return sessionStorage?.getItem(ErrorBoundarySessionStorageKey) || 'No error code found';
    };

    const buildMailToLink = (emailAddress?: string, subject?: string, body?: string) => {
        return `mailto:${emailAddress}?subject=${encodeURIComponent(subject || '')}&body=${encodeURIComponent(body || '')}`;
    };

    const copyErrorCodeToClipboard = () => {
        void navigator.clipboard.writeText(errorCode);
        setIsCopied(true);
    };

    const errorCode = getErrorCode();

    return (
        <>
            {errorCode !== 'Session storage is not available' && errorCode !== 'No error code found' && (
                <div className={`${CLASS_NAME} msc-section-box`}>
                    <div className={`${CLASS_NAME}__title`}>
                        <h4>{title}</h4>
                        <p>{text}</p>
                    </div>
                    <div className='alert alert-danger msc-alert'>
                        <div className={`${CLASS_NAME}__alert-info`}>
                            <strong>{props.resources.cipReportIssueAlertHeading}</strong>
                            <p className='copy-to-clipboard'>
                                {props.resources.cipReportIssueReferenceText}
                                <a
                                    className={`${CLASS_NAME}__link`}
                                    aria-label={`Copy error reference ${errorCode} to clipboard`}
                                    title='Copy reference code to clipboard'
                                    onClick={copyErrorCodeToClipboard}
                                >
                                    {errorCode}
                                </a>
                                <span className={`${CLASS_NAME}__copy-hint`}>({isCopied ? 'Copied' : 'Click to copy'})</span>
                            </p>
                        </div>
                        {emailAddress && (
                            <a
                                className='msc-btn msc-cta__primary'
                                href={buildMailToLink(
                                    props.config.emailAddress,
                                    replacePlaceholders(props.resources.cipReportIssueEmailSubject, { errorCode }),
                                    props.resources.cipReportIssueEmailBody
                                )}
                            >
                                {props.resources.cipReportIssueButtonText}
                            </a>
                        )}
                        {contactLink?.linkUrl?.destinationUrl && (
                            <a
                                className='msc-btn msc-cta__primary'
                                href={contactLink.linkUrl.destinationUrl}
                                aria-label={contactLink.ariaLabel}
                                target={contactLink.openInNewTab ? '_blank' : undefined}
                            >
                                {contactLink.linkText}
                            </a>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default CipReportIssueView;
